import { render } from "./GTranslate.vue?vue&type=template&id=6f0ec715"
import script from "./GTranslate.vue?vue&type=script&lang=js"
export * from "./GTranslate.vue?vue&type=script&lang=js"

import "./GTranslate.vue?vue&type=style&index=0&id=6f0ec715&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__